import { memo } from 'react'

import { SidebarDropdownItem } from '../components/sidebar-dropdown-item'
import { SidebarExpandableItem } from '../components/sidebar-expandable-item'
import { SidebarSimpleItem } from '../components/sidebar-simple-item'
import { SidebarItem, SidebarThemes } from '../types'

interface SidebarMenuItemProps {
  item: SidebarItem
  isSidebarOpen: boolean
  theme?: SidebarThemes
}

export const SidebarMenuItem = memo<SidebarMenuItemProps>(
  ({ item, isSidebarOpen, theme = 'light' }) => {
    const { subItems, subItemsState } = item

    const hasSubItems = subItems || subItemsState

    if (!hasSubItems) {
      return (
        <SidebarSimpleItem
          item={item}
          isSidebarOpen={isSidebarOpen}
          theme={theme}
        />
      )
    }

    if (!isSidebarOpen) {
      return <SidebarDropdownItem item={item} theme={theme} />
    }

    return <SidebarExpandableItem item={item} theme={theme} />
  },
)

SidebarMenuItem.displayName = 'SidebarMenuItem'
